import GameGrid from "./GameGrid";

export default function GameBoard({
  cards,
  flippedIndices,
  matchedCards,
  onCardClick,
  rows,
  cols,
}) {
  return (
    <GameGrid
      cards={cards}
      flippedIndices={flippedIndices}
      matchedCards={matchedCards}
      onCardClick={onCardClick}
      rows={rows}
      cols={cols}
    />
  );
}
